module.exports = __webpack_public_path__ + "9a23b73e275fdee3d127322eb3207744.png";